<template>
  <div class="container">
    <div class="nes-wrapper">
      <div class="nes-header">
<!--        <div class="header-item">{{title[getNewList.id]}}</div>-->
        <div
          v-for="(item,index) in getNewList.data"
          :key="item.id"
          v-if="index<4"
          @mouseover="setIndex(index)"
          class="header-item"
          @click="to(item.id)"
        >
          {{item.name}}
        </div>
<!--        <div  class="nes-add" @click="toList(getNewList.data[0].id)" >更多></div>-->
      </div>

      <div
        v-for="(i,index) in getNewList.data"
        :key="index"
        v-show="showIndex===index"
        class="news-item"
      >
        <div class="news-item-frist"
             v-if="i.content.length>0&&i.content[0].thumbnail"
        >
          <img :src="i.content[0].thumbnail"  @click="toDetail(i.content[0].id)" alt="">
          <div class="title">
<!--            <span @click="toDetail(i.content[0].id)" class="hover-s">{{i.name}}</span>-->
            <p @click="toDetail(i.content[0].id)" class="hover-s">{{i.content[0].title}}</p>
          </div>
        </div>
        <div
          v-for="(m,n) in i.content"
          :key="n"
          v-if="(i.content[0].thumbnail=='')||n>0"
          class="news-item-line"
          @click="toDetail(m.id)"
        >
      <span>
        <strong style="font-size: 10px">·</strong>
        {{m.title}}</span>
          <span style="flex-shrink: 0">{{m.check_time.substring(m.check_time.indexOf('-')+1,m.check_time.length)}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dian from '@/assets/dian.png'
export default {
  name: "Notaics",
  data(){
    return{
      logo:dian,
      showIndex:0,
      newList:[],
      title:['奋进新时代','党建引领','矿区动态','党风廉政','文艺天地','企业文化'],
      id:0,
      List:[],

    }
  },
  props:{
    getNewList:{
      default: null
    }
  },

  methods:{
    setIndex(index){
      this.showIndex=index
    },
    toList (id) {
      this.$router.push(`/news/${id}`)
    },
    to (id) {
      this.$router.push(`/news/${id}`)
    },
    toDetail (id) {
      this.$router.push(`/content/${id}`)
    }
  },
  updated() {
  }


}
</script>

<style scoped>
.nes-wrapper{
  width: 371px;
  height: 311px;
  background-color: white;
  padding: 10px;
  position: relative;
  font-family: inherit;
  overflow: hidden;
}
.nes-header{
  border-bottom: 1px solid #ccc;
  display: flex;
  align-items: center;
  width: 100%;
  height: 44px;
}
.header-item{
  display: flex;
  align-items: center;
  font-size: 14px;
  margin-right: 8px;
  height: 100%;
}
.header-item:first-child{
  font-size: 18px;
  font-weight: bold;
  color: #2574c2;
}
.header-item:hover{
  cursor: pointer;
  border-bottom: 2px solid #2574c2;
}
.news-item-line{
  display: flex;
  justify-content: space-between;
  padding: 4px 0;
  font-size: 14px;
  position: relative;
  /*width: 100%;*/
}
.news-item-line span:first-child:hover{
  color: #2574c2;
  cursor: pointer;
}
.news-item-line span:first-child{
  /*height: 20px;*/
  /*width: 70%;*/
  /*display: -webkit-box;*/
  /*-webkit-box-orient: vertical;*/
  /*-webkit-line-clamp: 1;*/
  /*overflow: hidden;*/
  /*width: 85%;*/
  font-size: 14px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;

  /*word-break: break-all;*/
}
.hover-s{
  min-width:200px ;
}
.hover-s:hover{
  cursor: pointer;
  color: #2574c2;
}
.nes-add{
  position: absolute;
  font-size: 14px;
  right: 5px;
}
.nes-add:hover{
  color: #2574c2;
  cursor: pointer;
}
.news-item-frist{
  margin-top: 10px;
  display: flex;
  justify-content: center;
  font-size: 14px;
}
.news-item-frist span{
  font-size: 14px;
  font-weight: 500;
}
.news-item-frist img{
  width: 160px;
  height: 100px;
  margin-right: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/Notaics.vue